import { Component, inject } from '@angular/core';
import { CustomerCompanyCodeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CustomerCompanyCodeCreateDto,
  CustomerCompanyCodeDto,
  CustomerCompanyCodeExcelDownloadDto,
  CustomerCompanyCodeUpdateDto,
} from '../proxy/controlling/dtos/customer-company-code';
import { CUSTOMERCOMPANYCODE_CONFIG, CUSTOMERCOMPANYCODE_FIELDS } from './customer-company-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-customer-company-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CustomerCompanyCodeService, ConfirmationService],
  templateUrl: './customer-company-code.html',
  styleUrl: './customer-company-code.scss',
})
export class CustomerCompanyCode extends BaseCrudComponent<
  CustomerCompanyCodeDto,
  CustomerCompanyCodeCreateDto,
  CustomerCompanyCodeUpdateDto,
  CustomerCompanyCodeExcelDownloadDto
> {
  service = inject(CustomerCompanyCodeService);
  config = CUSTOMERCOMPANYCODE_CONFIG;
  fields = CUSTOMERCOMPANYCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CustomerCompanyCodeDto): CustomerCompanyCodeUpdateDto {
    return {
      companyCode: data.companyCode,
      reconciliationAccount: data.reconciliationAccount,
      termsOfPayment: data.termsOfPayment,
      customerId: data.customerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CustomerCompanyCode';
  }
}
